import { ProfileHeader } from '#client/components/ProfileHeader';

import { useEnterpriseProfileHeader } from './hooks/useEnterpriseProfileHeader';

function EnterpriseProfileHeader() {
  const {
    formationDate,
    hasError,
    loading,
    name,
    nameInitials,
    statusItems
  } = useEnterpriseProfileHeader();

  return (
    <ProfileHeader
      formationDate={formationDate}
      hasError={hasError}
      loading={loading}
      name={name}
      nameInitials={nameInitials}
      statusItems={statusItems}
    />
  );
}

export default EnterpriseProfileHeader;
